import { render, staticRenderFns } from "./CustomTaggingForm.vue?vue&type=template&id=3e1f5c33&scoped=true&"
import script from "./CustomTaggingForm.vue?vue&type=script&lang=js&"
export * from "./CustomTaggingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1f5c33",
  null
  
)

export default component.exports